import * as Constants from '../constants';

const initialState = {};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

  	case Constants.GET_PAYMENT_GATEWAYS_START:
  	     return Object.assign({data: state.data,  action:action, loading: true});
    case Constants.GET_PAYMENT_GATEWAYS_SUCCESS:
        const paymentGateways = action.data && action.data.data && action.data.data.paymentGateways || [];
        const defaultOption = {name:'', id:-1};
        paymentGateways.unshift(defaultOption);
        return Object.assign({data: action.data,  action:action, loading: false});
    case Constants.GET_PAYMENT_GATEWAYS_FAILURE:
         return Object.assign({data: action.data, action:action, loading: false});
    case Constants.SELECT_ADDRESS_SUCCESS:
          return initialState;
    default:
      return { ...state };
  }
}
